import { useSelector } from 'react-redux';
import { getCollaborationSidebarState } from 'ContentEditorUI/redux/selectors/collaborationSidebarSelectors';
import CommentModeCursorTooltip from 'collaboration-sidebar/features/deepCommenting/components/CommentModeCursorTooltip';
import { NAMESPACE_CLASS } from 'EmailEditorUI/components/NamespaceWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CommentableAreaCursorTooltip() {
  const collaborationSidebarState = useSelector(getCollaborationSidebarState);
  return collaborationSidebarState.isCommentModeActive && /*#__PURE__*/_jsx(CommentModeCursorTooltip, {
    elementName: "hubspot-disable-focus-styles",
    portalClassnameWrapper: NAMESPACE_CLASS
  });
}